import { gql } from "@apollo/client";

export const CREATE_OR_UPDATE_USER = () => {
  return gql`
    mutation CreateOrUpdateUser(
      $createOrUpdateUserInput: CreateOrUpdateUserInput!
    ) {
      createOrUpdateUser(createOrUpdateUserInput: $createOrUpdateUserInput)
    }
  `;
};

export const GET_USERS_LIST = () => {
  return gql`
    query GetUsersList($getUsersListInput: GetUsersListInput!) {
      getUsersList(getUsersListInput: $getUsersListInput) {
        count
        pagination {
          total
          pages
          limit
          cur_page
          prev_page
          next_page
        }
        tabsCount {
          Active
          Inactive
        }
        rows {
          id
          username
          email
          name
          mobile
          status
          created_by_user {
            id
            name
          }
          updated_by_user {
            id
            name
          }
          created_date
          updated_date
        }
      }
    }
  `;
};
